<template>
	<div id="empresa-adicionar">
		<ld-popup
			id="popup-adicionar-empresa"
			:fullscreen="true"
			:active.sync="popupAdicionarEmpresa"
			:button-close-hidden="true"
			:disabledBackgoundClose="true"
			:closed="funcaoFechar"
		>

			<div class="flex justify-between w-full p-2 pb-5" slot="header">
				<div class="flex items-center w-1/2">
					<div class="content-title mr-32">
						<h2 class="title">Adicionar empresa</h2>
					</div>
				</div>
				<ld-button
					icon-pack="feather"
					icon="icon-x"
					size="large"
					color="dark"
					type="flat"
					@click="popupCancelarCadastro = true"
				></ld-button>
			</div>

			<vx-card>
				<form
					id="form-empresa-adicionar"
					class="relative py-5 px-4"
					@submit.prevent="adicionarEmpresa"
				>
					<div class="flex flex-col w-full">
						<div class="dados-empresa">
							<h4 class="subtitle my-10 font-bold">Dados da empresa</h4>

							<vs-input
								class="w-full mb-4"
								label="Nome"
								name="nome"
								v-model="empresa.nome"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="Nome fantasia"
								name="fantasia"
								v-model="empresa.nomeFantasia"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="CNPJ"
								name="cnpj"
								v-mask="'##.###.###/####-##'"
								v-model="empresa.cnpj"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="E-mail"
								name="email"
								v-model="empresa.email"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="Telefone"
								name="telefone"
								v-mask="['(##) # ####-####', '(##) ####-####']"
								v-model="empresa.telefone"
							></vs-input>
						</div>

						<div class="endereco">
							<h4 class="subtitle my-10 font-bold">Endereço</h4>

							<vs-input
								class="w-full mb-4"
								label="CEP"
								name="cep"
								v-mask="'#####-###'"
								v-model="empresa.cep"
								@input="consultarCEP"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="Rua"
								name="logradouro"
								v-model="empresa.logradouro"
							></vs-input>

							<vs-input
								class="md:w-2/5 w-full mb-4"
								label="Número"
								name="numero"
								type="number"
								v-model="empresa.numero"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="Complemento (Opcional)"
								name="complemento"
								v-model="empresa.complemento"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="Bairro"
								name="bairro"
								v-model="empresa.bairro"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="Cidade"
								name="cidade"
								v-model="empresa.cidade"
							></vs-input>

							<ld-select
								parent="#form-empresa-adicionar"
								label="Estado"
								name="estado"
								:model.sync="empresa.estado"
								:list.sync="listEstados"
							/>
						</div>
					</div>

					<div class="flex flex-wrap items-center justify-end mt-10">
						<ld-button
							class="mr-4 mt-2"
							type="border"
							@click="popupCancelarCadastro = true"
							>Cancelar</ld-button
						>
						<ld-button class="mt-2" buttonType="submit"
							>Adicionar empresa</ld-button
						>
					</div>
				</form>
			</vx-card>

			<ld-popup
				title="Cancelar cadastro?"
				:active.sync="popupCancelarCadastro"
				:button-close-hidden="true"
			>
				<p>
					Tem certeza que deseja cancelar o cadastro da empresa? Se
					cancelar, todos os dados inseridos serão perdidos.
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<ld-button
							buttonType="submit"
							class="w-20 mr-4"
							color="danger"
							type="filled"
							@click="cancelarCadastro"
							>Cancelar cadastro</ld-button
						>

						<ld-button
							class="w-15"
							color="dark"
							type="flat"
							@click="popupCancelarCadastro = false"
							>Voltar</ld-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				title="Empresa adicionada"
				:active.sync="popupEmpresaAdicionada"
				:button-close-hidden="true"
				:disabledBackgoundClose="true"
			>
				<p>A empresa "{{ empresa.nome }}" foi adicionada.</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<vs-button
							class="w-32"
							color="primary"
							type="filled"
							@click="cadastroFinalizado"
							>OK</vs-button
						>
					</div>
				</div>
			</ld-popup>
		</ld-popup>
	</div>
</template>

<script>
import Empresa from "../../../models/Empresa";
import ErrorHelper from "../../../helpers/ErrorHelper";
import CEPHelper from "../../../helpers/CEPHelper";
import Estado from "../../../models/Estado";

export default {
	name: "EmpresaAdicionar",
	data() {
		return {
			empresa: new Empresa({}),
			popupCancelarCadastro: false,
			popupEmpresaAdicionada: false
		};
	},
	props: {
		active: {
			type: Boolean,
			default: false
		},
		closed: {
			type: Function,
			required: false
		},
	},
	computed: {
		popupAdicionarEmpresa: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
			}
		},
		listEstados() {
			const estados = Estado.getMap();

			const listEstados = [
				{},
				...Object.keys(estados).map(estado => {
					return {
						text: estado,
						value: estados[estado]
					};
				})
			];

			return listEstados;
		}
	},
	methods: {
		async adicionarEmpresa() {
			const loadingAdicionarEmpresa = this.$vsloading({
				container: "#popup-adicionar-empresa",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				await Empresa.criar(this.empresa);
				this.popupEmpresaAdicionada = true;
			} catch (error) {
				ErrorHelper.renderFormError("#form-empresa-adicionar", error);
			} finally {
				loadingAdicionarEmpresa.hide();
			}
		},
		cancelarCadastro() {
			this.empresa = new Empresa({});
			this.popupCancelarCadastro = false;
			this.popupAdicionarEmpresa = false;
		},
		cadastroFinalizado() {
			this.empresa = new Empresa({});
			this.popupEmpresaAdicionada = false;
			this.popupAdicionarEmpresa = false;
		},
		funcaoFechar() {
			if (this.closed) {
				this.closed();
			}

			const form = document.querySelector("#form-empresa-adicionar");
			ErrorHelper.cleanFormErrors(form);
		},
		async consultarCEP(cep) {
            try {
                await CEPHelper.consultarCEP.get(cep, this.empresa);
            } catch (error) {
                console.error(error)
            }
        },
	},
};
</script>

<style lang="scss" src="./empresa_adicionar.scss"></style>
